import { render, staticRenderFns } from "./ProducerProductGroups.vue?vue&type=template&id=95bd6eca&"
import script from "./ProducerProductGroups.vue?vue&type=script&lang=js&"
export * from "./ProducerProductGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports